export const SET_DEFAULT_SUCCESS = 'Default business unit updated';
export const SET_DEFAULT_ERROR = 'Something went wrong. Please try again.';

export const SET_DEFAULT_MODAL_TEST_ID =
  'developers_business_units_set-default-modal';
export const SET_DEFAULT_CONFIRM_TEST_ID =
  'developers_business_units_set-default_confirm-btn';
export const SET_DEFAULT_CANCEL_TEST_ID =
  'developers_business_units_set-default_cancel-btn';

export const SET_DEFAULT_MODAL_WIDTH = 480;

export const SET_DEFAULT_TITLE = 'Set as default business unit';
export const SET_DEFAULT_CONFIRM_LABEL = 'Set as default';
export const setDefaultBody = (name: string) =>
  `Make “${name}” the default business unit? New payments and integrations will use it unless another unit is specified.`;

export const RENAME_BUSINESS_UNIT_FORM_ID = 'rename-business-unit-form';
export const RENAME_BUSINESS_UNIT_SUCCESS = 'Business unit renamed';
export const RENAME_BUSINESS_UNIT_GENERIC_ERROR = 'Something went wrong';

export const RENAME_BUSINESS_UNIT_MODAL_TEST_ID =
  'developers_business_units_rename';
export const RENAME_BUSINESS_UNIT_NAME_TEST_ID =
  'developers_business_units_rename_name-input';
export const RENAME_BUSINESS_UNIT_SUBMIT_TEST_ID =
  'developers_business_units_rename_submit-btn';
export const RENAME_BUSINESS_UNIT_CANCEL_TEST_ID =
  'developers_business_units_rename_cancel-btn';

export const RENAME_BUSINESS_UNIT_TITLE = 'Rename business unit';
export const RENAME_BUSINESS_UNIT_NAME_LABEL = 'Name';
export const RENAME_BUSINESS_UNIT_NAME_PLACEHOLDER = 'e.g. Acme EU';
export const RENAME_BUSINESS_UNIT_SUBMIT_LABEL = 'Save';
export const RENAME_BUSINESS_UNIT_CANCEL_LABEL = 'Cancel';

export const DELETE_BUSINESS_UNIT_SUCCESS = 'Business unit deleted';
export const DELETE_BUSINESS_UNIT_GENERIC_ERROR = 'Something went wrong';

export const DELETE_BUSINESS_UNIT_MODAL_TEST_ID =
  'developers_business_units_delete-modal';
export const DELETE_BUSINESS_UNIT_CONFIRM_TEST_ID =
  'developers_business_units_delete_confirm-btn';
export const DELETE_BUSINESS_UNIT_CANCEL_TEST_ID =
  'developers_business_units_delete_cancel-btn';

export const DELETE_BUSINESS_UNIT_MODAL_WIDTH = 420;

export const DELETE_BUSINESS_UNIT_TITLE = 'Delete business unit';
export const DELETE_BUSINESS_UNIT_CONFIRM_LABEL = 'Delete';
export const deleteBusinessUnitBody = (name: string) =>
  `Delete “${name}”? This action cannot be undone.`;

export const BUSINESS_UNIT_CARD_ACTIONS_TRIGGER_TEST_ID = (uuid: string) =>
  `developers_business_units_card_actions-btn-${uuid}`;
export const BUSINESS_UNIT_CARD_RENAME_OPTION_TEST_ID = (uuid: string) =>
  `developers_business_units_card_rename-option-${uuid}`;
export const BUSINESS_UNIT_CARD_SET_DEFAULT_OPTION_TEST_ID = (uuid: string) =>
  `developers_business_units_card_set-default-option-${uuid}`;
export const BUSINESS_UNIT_CARD_DELETE_OPTION_TEST_ID = (uuid: string) =>
  `developers_business_units_card_delete-option-${uuid}`;

export const RENAME_LABEL = 'Rename';
export const SET_DEFAULT_LABEL = 'Set as default';
export const SET_DEFAULT_DISABLED_REASON = 'Already the default';
export const DELETE_LABEL = 'Delete';
export const DELETE_DISABLED_REASON = 'Default unit cannot be deleted';
